import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Navigation({ activeTab }) {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleEmailAdmin = () => {
    // Admin email addresses
    const adminEmails = ['Mike.Lyons@us.psm.com', 'PSMShipment@us.psm.com'];

    const subject = 'Shipping Portal Request';
    const body = 'Hello,\n\nI have a question regarding:\n\n';

    // Create mailto link
    const mailtoLink = `mailto:${adminEmails.join(',')}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // Open default email client
    window.location.href = mailtoLink;
  };

  const handleReferences = () => {
    navigate('/references');
  };

  return (
    <>
      <div className="nav-tabs">
        <button
          className={`nav-tab ${activeTab === 'my-shipments' ? 'active' : ''}`}
          onClick={() => navigate('/dashboard')}
        >
          My Shipments
        </button>
        <button
          className={`nav-tab ${activeTab === 'new-shipment' ? 'active' : ''}`}
          onClick={() => navigate('/new-shipment')}
        >
          New Domestic Shipment
        </button>
        <button
          className={`nav-tab ${activeTab === 'new-intl-shipment' ? 'active' : ''}`}
          onClick={() => navigate('/new-intl-shipment')}
        >
          New Int'l Shipment
        </button>
        <button
          className={`nav-tab ${activeTab === 'address-book' ? 'active' : ''}`}
          onClick={() => navigate('/address-book')}
        >
          Address Book
        </button>
        {['admin', 'super_admin'].includes(user?.role) && (
          <>
            <button
              className={`nav-tab ${activeTab === 'admin' ? 'active' : ''}`}
              onClick={() => navigate('/admin')}
            >
              Admin
            </button>
            <button
              className={`nav-tab ${activeTab === 'system-monitor' ? 'active' : ''}`}
              onClick={() => navigate('/system-monitor')}
            >
              System Monitor
            </button>
          </>
        )}
      </div>

      <div className="secondary-nav">
        <button onClick={handleEmailAdmin}>Email Admin</button>
        <span style={{ color: 'white' }}>/</span>
        <button onClick={handleReferences}>References</button>
      </div>
    </>
  );
}

export default Navigation;
